import { render } from "./IconMenu.vue?vue&type=template&id=49453d62&scoped=true"
import script from "./IconMenu.vue?vue&type=script&lang=js"
export * from "./IconMenu.vue?vue&type=script&lang=js"

import "./IconMenu.vue?vue&type=style&index=0&id=49453d62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49453d62"]])

export default __exports__